import React from 'react';
import * as C from "../componentsM/index";

const BoardOfGoverners = () => <>
    <C.Hero title={"BOARD OF GOVERNORS"} image={"/hero/governce.jpg"} />

    <section className='p-4 md:p-24'>

        <h6 className='mb-4'>Taymur Mirza </h6>


        <h6 className='mb-4'>Chairperson </h6>

        <h6 className='mb-4'>B.A. (Mathematics, Computer Science) </h6>

        <h6 className='mb-4'>M.A. (Applied Educational Leadership & Management – in Progress)</h6>



        <h6 className='mb-4'>As a social entrepreneur interested in the field of education management and promotion, Taymur Mirza established, in 1996, the first International Baccalaureate (www.ibo.org) World School, for students aged 3 to 18 years, in Pakistan and is currently involved in the day-to-day management of the concern. Whilst still involved with the school, he has been provided numerous opportunities by the affiliate International Baccalaureate Organisation in the capacity of education programme evaluator, presenter, subject examiner and workshop leader.</h6>


        <h6 className='mb-4'>The exposure to education commenced in the first year of reading Mathematics at Rutgers University in New Jersey, U.S.A. Taymur Mirza may have accepted the offer to be a peer tutor, by the Mathematics Department of the University, as an opportunity to earn income from this part-time job. However, the experience in tutoring his peers at college developed an affinity for teaching and education. During these informative, developmental years his passion for education was overshadowed by his pursuit of becoming an Actuary Fellow. With the achievement of passing the initial actuary exams, Taymur Mirza was selected for the highly sought internship programme at Prudential Property & Casualty Insurance Company situated in Holmdel, New Jersey.</h6>



        <h6 className='mb-4'>The return to Pakistan, soon after his graduation from Rutgers University, landed him in an unexpected role of providing private Mathematics tutorials to students writing the British General Certificate of Educations’ Ordinary and Advanced level Mathematics examination. The success of this offered service in record time with attractive monetary gains only confirmed the opportunity in providing quality education in Pakistan. This led to conducting a marketing survey, preparing financial model for an IB World School, raising of equity capital from the private sector and launching of The International School, the first and only world school in Pakistan.

            As Secretary of the company’s Board, he is currently finalising expansion plans for Tyms Education Ltd, the management firm which owns and manages The International School.</h6>



        <h6 className='mb-4'>He serves as a Trustee of Indus Earth, a non-profit organisation committed to empowering the “poor” and of NITRO, a non-profit committed to the promotion of sporting activities in Karachi, Pakistan.</h6>


        <hr className='bg-gray-400' />



        <h6 className='mb-4'>Maheen Khan</h6>



        <h6 className='mb-4'>Member of the Board</h6>


        <h6 className='mb-4'>For Pakistan’s Coco Chanel, Maheen , fashion is a lifestyle, her lifestyle. As the very foundation of Pakistan’s fashion history and as a young woman entrepreneur in the 70s she has designed through the country’s best and worst times, always staying on top of her game, devoted to her industry. A true leader, the ‘’mother’’ of fashion, she is a living institution.</h6>


        <h6 className='mb-4'>Pakistan’s first Fashion Designer and the principal force behind the formation of “Fashion Pakistan Council.”</h6>


        <h6 className='mb-4'>A proud Pakistani, she has been an ambassador through Fashion, taking Pakistan’s softer image across the globe and has with her pioneering efforts created that channel for others to get international exposure too.</h6>


        <h6 className='mb-4'>In 2007, she created edgy ‘GULABO’ Inspired by the people’s folk visual art – ‘Truck Art’ and the Pakistani love for color. This trend has been picked up by designers across Pakistan.</h6>



        <h6 className='mb-4'>From creating Benazir Bhutto’s signature look of white head scarf and green top, to the introduction of ready to wear, her scope of impact has been pivotal throughout the history of Pakistani fashion.</h6>

        And she continues today to design, lead, inspire, motivate and mentor.

    </section>

</>

export default BoardOfGoverners